import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

// env
import { environment } from './../../../../environments/environment';

// Plugin
import { Lightbox } from 'ngx-lightbox';
import { LightboxConfig } from 'ngx-lightbox';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-article-detail',
  templateUrl: './article-detail.component.html',
  styles: [
  ]
})
export class ArticleDetailComponent implements OnInit, OnDestroy {

  slugArticle;
  colorBg;
  apiAsset = environment.API_ASSETS;
  dataArticle;
  dataTags = [];
  paramsSubscription:Subscription;
  _albums = [];
  isLang;

  constructor(private activedRoute: ActivatedRoute,
              private lightbox: Lightbox, 
              public globalService : GlobalService,
              private apiService: ApiService,
              private router: Router,
              private _lightboxConfig: LightboxConfig){ 
      _lightboxConfig.centerVertically = true;
      _lightboxConfig.disableScrolling = true;
      this.globalService.isLoading.next(true);
  }

  ngOnInit(): void {
    this.paramsSubscription = this.activedRoute.params.subscribe(params => {
      this.dataTags = [];
      this._albums = [];
      this.globalService.isLoading.next(true);
      this.slugArticle = params['slug'];

      // MultiLanguage
      this.isLang = this.apiService.isLang();

      this.apiService.getDataApi('getSubHeaderByLink/news-and-events').subscribe(response => {
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
      });

      this.apiService.getDataApi('getNewsReleaseDetail/'+params['title']).subscribe(response => {
        if(response.success) {
          // content
          this.dataArticle = response.data;

          // gallery
          if(response.data.current.gallery != null){
            let temp = '';
            let gallery = [];
            let gal = response.data.current.gallery;
            for(let i = 0; i <= gal.length; i++){
                if(gal[i] == ','){
                  gallery.push(temp);
                  temp = '';
                }else{
                  temp = temp + gal[i];
                }
            };
            gallery.map((v, i) => {
              const src = this.apiAsset + v;
              const album = {
                  src: src
              };
              this._albums.push(album);
            });
          }

          // tags
          if(response.data.current.tag != null){
            let temp2 = '';
            let tags = response.data.current.tag;
            for(let i = 0; i <= tags.length; i++){
                if(tags[i] == ','){
                  this.dataTags.push(temp2);
                  temp2 = '';
                }else{
                  temp2 = temp2 + tags[i];
                }
            };
          }

          // color
          if(this.slugArticle == 'news'){
            this.colorBg = 'light-blue';
          } 
          else if (this.slugArticle == 'investor-updates'){
            this.colorBg = 'red';
          }
          else if (this.slugArticle == 'events'){
            this.colorBg = 'dark-blue';
          }
          
          this.globalService.isLoading.next(false);
        }else {
          this.router.navigate(['/not-found']);
        }
      });
    })
  }

  open(index: number): void {
    // open lightbox
    this.lightbox.open(this._albums, index);
  }
 
  close(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }

  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }

}
